exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matched-condition-label-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-start;\n  max-width: 400px;\n  background-color: #c0e7c7;\n  padding: 0 7px;\n  border-radius: 4px;\n}\n", ""]);

// exports
